// #region imports

// --- Angular
import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnDestroy, Output, ViewChild } from '@angular/core';

// --- RxJs
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { delay, switchMap } from 'rxjs/operators';

// --- 3rd Party
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

// --- HS Code
import { FormatingTypes } from '../../models';


// #endregion

@Component({
  selector: 'hs-pin-journal',
  templateUrl: './pin-journal.component.html',
  styleUrls: ['./pin-journal.component.scss']
})
export class PinJournalComponent implements AfterViewInit, OnDestroy {

  @Input() resourceKey: string = '';
  @Input() resourceKeys: string[] | null = null;
  @Input() pinned: boolean = false;
  @Input() formatingType: FormatingTypes = FormatingTypes.Unknown;

  @Output() pinJournalEntry = new EventEmitter<string>();
  @Output() unpinJournalEntry = new EventEmitter<string>();

  @ViewChild('tooltip', {static: true}) private _tooltipRef: NgbTooltip | undefined;

  formatingTypes = FormatingTypes;

  private _focused$: BehaviorSubject<boolean>;
  get focused$(): Observable<boolean> {
    return this._focused$;
  }

  active$: BehaviorSubject<boolean>;

  private _focusedSubscription: Subscription = Subscription.EMPTY;

  constructor() {
    this._focused$ = new BehaviorSubject<boolean>(false);
    this.active$ = new BehaviorSubject<boolean>(false);
  }

  ngAfterViewInit() {
    this._focusedSubscription = this.focused$
    .pipe(
      switchMap((focused: boolean) => {
        if (focused) {
          return of(true).pipe(delay(200));
        }
        return of(false).pipe(delay(200));
      }),
    ).subscribe((focused) => {
      this.active$.next(focused);
      if (focused) {
        this._tooltipRef?.open();
        return;
      }
      this._tooltipRef?.close();
    });
  }

  ngOnDestroy(): void {
    if (this._focusedSubscription) {
      this._focusedSubscription.unsubscribe();
      this._focusedSubscription = Subscription.EMPTY;
    }
    this.active$.complete();
    this._focused$.complete();
  }

  onTogglePin() {
    if (!this.pinned) {
      this.pinJournalEntry.emit(this.resourceKey);
      return;
    }
    this.unpinJournalEntry.emit(this.resourceKey);
  }

  onMouseEnter(event: Event) {
    this._focused$.next(true);
  }

  onMouseLeave(event: Event) {
    this._focused$.next(false);
  }
}
